import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const DrawerContext = createContext({
  isOpen: false,
  activeTab: "summary",
  data: {
    summary: "",
    events: [],
    audit: [],
    rawJson: null,
    copyItems: [],
  },
  setDrawerData: () => {},
  clearDrawerData: () => {},
  openDrawer: () => {},
  closeDrawer: () => {},
});

export function DrawerProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("summary");
  const [data, setData] = useState({
    summary: "",
    events: [],
    audit: [],
    rawJson: null,
    copyItems: [],
  });

  const setDrawerData = useCallback((next) => {
    setData((prev) => ({ ...prev, ...(next || {}) }));
  }, []);

  const clearDrawerData = useCallback(() => {
    setData({
      summary: "",
      events: [],
      audit: [],
      rawJson: null,
      copyItems: [],
    });
  }, []);

  const openDrawer = useCallback((tab) => {
    if (tab) setActiveTab(tab);
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      isOpen,
      activeTab,
      data,
      setDrawerData,
      clearDrawerData,
      openDrawer,
      closeDrawer,
    }),
    [isOpen, activeTab, data, setDrawerData, clearDrawerData, openDrawer, closeDrawer]
  );

  return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
}

export function useDrawer() {
  return useContext(DrawerContext);
}
